import React, { useMemo, useState } from "react";
import { Box, Typography, Button } from "@mui/material";

const BulkUploadPreview = ({ rows = [], maxRows = 5 }) => {
  const [showAll, setShowAll] = useState(false);

  const { displayRows, remainingCount } = useMemo(() => {
    if (!rows?.length) {
      return { displayRows: [], remainingCount: 0 };
    }
    if (showAll) {
      return { displayRows: rows, remainingCount: 0 };
    }
    const limited = rows.slice(0, maxRows);
    return { displayRows: limited, remainingCount: rows.length - limited.length };
  }, [rows, maxRows, showAll]);

  if (!displayRows.length) return null;

  return (
    <Box
      mt={1}
      sx={{
        maxHeight: 200,
        overflow: "auto",
        bgcolor: "#f9fafb",
        borderRadius: 1,
        p: 1,
      }}
    >
      {displayRows.map((row) => {
        const policyNumber =
          row.__extracted?.policyNumber ||
          row.policy_number ||
          row.policy_no ||
          "-";
        const missingFields = row.__missingFields || [];
        const warnings = row.__warnings || [];
        const hasMissing = missingFields.length > 0;
        const hasWarnings = warnings.length > 0;
        const hasIssues = hasMissing || hasWarnings;

        return (
          <Box key={row.__rowNumber} sx={{ mb: 1 }}>
            <Typography variant="caption" sx={{ color: "#1f2937" }}>
              Row {row.__rowNumber} → Policy: {policyNumber || "-"}
            </Typography>
            <Typography
              variant="caption"
              color={hasIssues ? "warning.main" : "success.main"}
              display="block"
              sx={{ mt: 0.5 }}
            >
              Row ready for upload
              {hasMissing
                ? ` – missing field${missingFields.length > 1 ? "s" : ""}: ${missingFields.join(
                  ", "
                )}`
                : ""}
            </Typography>
            {hasWarnings && (
              <Typography
                variant="caption"
                color="warning.main"
                display="block"
                sx={{ mt: 0.5, fontStyle: "italic" }}
              >
                {warnings.map((warning, idx) => (
                  <span key={idx}>
                    {warning}
                    {idx < warnings.length - 1 ? "; " : ""}
                  </span>
                ))}
              </Typography>
            )}
          </Box>
        );
      })}
      {remainingCount > 0 && (
        <Button
          variant="text"
          size="small"
          onClick={() => setShowAll(true)}
          sx={{ mt: 1, textTransform: "none" }}
        >
          +{remainingCount} more row{remainingCount > 1 ? "s" : ""} (show all)
        </Button>
      )}
    </Box>
  );
};

export default BulkUploadPreview;

